const browseActionConstants = {
  SET_SORTBY: 'SET_SORTBY',
  RESET_OPENINGS: 'RESET_OPENINGS',
  SET_REQUEST_ID: 'SET_REQUEST_ID',
  SET_OPENING_DETAIL_REQUEST_ID: 'SET_OPENING_DETAIL_REQUEST_ID',
  GET_OPENINGS_SUCCESS: 'GET_OPENINGS_SUCCESS',
  GET_OPENINGS_DETAILS: 'GET_OPENINGS_DETAILS',
  GET_SEARCH_OPENINGS_SUCCESS: 'GET_SEARCH_OPENINGS_SUCCESS',
  GET_SEARCH_OPENINGS_LOADING_ON: 'GET_SEARCH_OPENINGS_LOADING_ON',
  GET_SEARCH_OPENINGS_LOADING_OFF: 'GET_SEARCH_OPENINGS_LOADING_OFF',
  FETCH_NEXT_OPENINGS: 'FETCH_NEXT_OPENINGS',
  SET_OPENING_LIST_LOADING_ON: 'SET_OPENING_LIST_LOADING_ON',
  SET_OPENING_LIST_LOADING_OFF: 'SET_OPENING_LIST_LOADING_OFF',
  SET_OPENING_DETAILS_LOADING_ON: 'SET_OPENING_DETAILS_LOADING_ON',
  SET_OPENING_DETAILS_LOADING_OFF: 'SET_OPENING_DETAILS_LOADING_OFF',
  SET_MORE_JOBS_LOADING_ON: 'SET_MORE_JOBS_LOADING_ON',
  SET_MORE_JOBS_LOADING_OFF: 'SET_MORE_JOBS_LOADING_OFF',
};

export default browseActionConstants;
